import { WallType } from '@app-types/config';
import { SalesWallType } from '@app-types/sales';

export const paths = {
    index: '/',
    phoneWall: '/telephones-mobiles',
    renewalPhoneWall: `/telephones-mobiles/renouvellement`,
    phoneDetail: (slug: string, isRenewal: boolean = false) =>
        `${paths.phoneWall}/${isRenewal ? 'renouvellement/' : ''}${slug}`,
    phoneFilter: (isRenewal: boolean, filter: string) =>
        `${isRenewal ? paths.renewalPhoneWall : paths.phoneWall}/filtre/${filter}`,
    accessoryWall: '/accessoires',
    accessoryDetail: (slug: string) => `${paths.accessoryWall}/${slug}`,
    accessoryFilter: (filter: string) => `${paths.accessoryWall}/filtre/${filter}`,
    hotspotDetail: (slug: string) => `/hotspot-tablette/${slug}`,
    productDetail: (type: WallType, slug: string, isRenewal: boolean = false) => {
        switch (type) {
            case WallType.ACCESSORY:
                return paths.accessoryDetail(slug);
            case WallType.PHONE:
                return paths.phoneDetail(slug, isRenewal);
            case WallType.HOTSPOT:
                return paths.hotspotDetail(slug);
            case WallType.SALES_PHONE:
                return paths.salesProduct(SalesWallType.PHONE, slug);
            case WallType.SALES_ACCESSORY:
                return paths.salesProduct(SalesWallType.ACCESSORY, slug);
            default:
                return paths.index;
        }
    },
    hotspotWall: '/hotspot-tablette',
    productWall: (type: WallType) => {
        switch (type) {
            case WallType.ACCESSORY:
                return paths.accessoryWall;
            case WallType.SALES_ACCESSORY:
                return paths.sales(SalesWallType.ACCESSORY);
            case WallType.PHONE:
                return paths.phoneWall;
            case WallType.SALES_PHONE:
                return paths.sales(SalesWallType.PHONE);
            case WallType.HOTSPOT:
                return paths.hotspotWall;
            default:
                return paths.index;
        }
    },
    directCart: (planId: string, faiRange: string, from?: string) => {
        const hasFrom = from ? `&from=${from}` : '';
        return `${paths.mixedCartEligibility}?plan_id=${planId}&gamme=${faiRange}${hasFrom}`;
    },
    homeFai: '/offres-internet',
    homePack: '/offres-internet/combo-box',
    homePackSmartTv: '/offres-internet/combo-box/smart-tv',
    promos: '/offres-box-forfait',
    crossSell: (origin?: string) => {
        const originParam = origin ? `?origin=${origin}` : '';
        return `/personnaliser-mon-offre${originParam}`;
    },
    plans: '/forfaits-mobiles/avec-engagement',
    cart: '/panier',
    recall: (id: string, isPro?: boolean, isEDF?: boolean) => {
        if (isPro) return `/rappelez-moi?type=pro`;
        if (isEDF) return `/rappelez-moi?callback=tlvctcedfdem`;
        return `/rappelez-moi?callback=${id}`;
    },
    mixedCartEligibility: '/offres-internet/test-eligibilite-panier-mixte',
    gamingEligibility: '/offres-internet/test-eligibilite-gaming',
    tabletEligibility: '/offres-internet/test-eligibilite-tablette',
    smartTvEligibility: '/offres-internet/test-eligibilite-smart-tv',
    youngEligibility: '/offres-internet/test-eligibilite-moins-26-ans',
    bankEligibility: '/offres-internet/test-eligibilite-bboxbanque',
    promoEligibility: '/offres-internet/test-eligibilite-promo',
    extraBoxEligibility: '/offres-internet/test-eligibilite-bbox-extra',
    eligibilityTest: '/offres-internet/test-eligibilite',
    eligibilityTestTech: '/offres-internet/test-eligibilite-tech',
    offersComparator: '/offres-internet/comparateur',
    mobileComparator: (isRenewal: boolean, products: string[]) =>
        `/comparateur?produits=${products.join(',')}${isRenewal ? '&renewal=true' : ''}`,
    migrationOffer: (contractId: string) => `/mon-compte/changement-forfait/${contractId}`,
    clientSpace: '/mon-compte',
    sales: (type: SalesWallType) => `/bons-plans/soldes/${type}`,
    salesFilter: (type: SalesWallType, filter: string) => `/bons-plans/soldes/${type}/filtre/${filter}`,
    salesProduct: (type: SalesWallType, slug: string) => `/bons-plans/soldes/${type}/${slug}`,
    odr: `/bons-plans/offres-de-remboursement`,
    kidsWatch: '/kids-watch',
};

const INDEX_WEB_API = '/webapi';
export const localApiPaths = {
    authentification: {
        auth: `${INDEX_WEB_API}/auth`,
        session: `${INDEX_WEB_API}/auth/session`,
    },
    planDetails: `${INDEX_WEB_API}/cms/plan-details`,
    reviews: `${INDEX_WEB_API}/reviews`,
    wall: `${INDEX_WEB_API}/wall`,
    wallSearchList: `${INDEX_WEB_API}/wall/search-list`,
    stickers: `${INDEX_WEB_API}/wall/stickers`,
    fai: `${INDEX_WEB_API}/fai`,
    product: `${INDEX_WEB_API}/product`,
    productStock: `${INDEX_WEB_API}/product/stock`,
};
